import { useTranslation } from "react-i18next";

export default function NostalgiaChange() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-primary-700 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-4">
          <div className="text-xs uppercase tracking-[0.35em] text-accent-300 mb-3">
            — {t("nost_change_eyebrow")} —
          </div>
          <h2 className="font-heading text-3xl md:text-4xl leading-[1.1] tracking-tight mb-6">
            {t("nost_change_title")}
          </h2>
          <div className="w-16 h-px bg-accent-400/60 mb-6"></div>
          <p className="text-background-100/70 text-sm leading-relaxed">
            {t("nost_change_quote_author")}
          </p>
        </div>

        <div className="lg:col-span-8 space-y-5">
          <p className="text-background-100/90 leading-relaxed text-base md:text-lg">
            {t("nost_change_p1")}
          </p>
          <p className="text-background-100/80 leading-relaxed text-base">
            {t("nost_change_p2")}
          </p>
          <p className="text-background-100/80 leading-relaxed text-base">
            {t("nost_change_p3")}
          </p>
          <p className="text-background-100/80 leading-relaxed text-base">
            {t("nost_change_p4")}
          </p>

          <blockquote className="mt-8 border-l-2 border-accent-400 pl-5 md:pl-6">
            <p className="font-heading text-xl md:text-2xl leading-relaxed text-background-50">
              „{t("nost_change_quote")}“
            </p>
          </blockquote>
        </div>
      </div>
    </section>
  );
}